import { Button, Container, Heading, VStack } from '@chakra-ui/react';
import React from 'react';
import { RiErrorWarningFill } from 'react-icons/ri';
import { Link } from 'react-router-dom';

const Paymentfail = () => {
  return (
    <Container h={'90vh'} p="16">
      <VStack justifyContent={'center'} h="full" spacing="4">
        <RiErrorWarningFill size={'5rem'} />
        <Heading
          my="8"
          textAlign={'center'}
          textTransform="uppercase"
          children="Page Fail"
        />

        <Link to="/subscribe">
          <Button variant={'ghost'}>Try Again</Button>
        </Link>
      </VStack>
    </Container>
  );
};

export default Paymentfail;
